import Vue from "vue";
import Vuex from "vuex";
import { resetRouter } from "../router/index";
Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    user: false,
    isLogin: false
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    },
    // 退出
    logout(state, user) {
      state.user = "";
      localStorage.clear();
      resetRouter();
      // location.reload();
    }
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js